import React, { useEffect, useState } from 'react';
import { CContainer, CRow, CCol, CCard, CCardBody } from '@coreui/react';

import logo_stream from 'assets/brand/logo_stream.png';

const IdiSurveyCompleted = () => {
    return (
        <CContainer>
            <CRow className="justify-content-center my-4">
                <CCol md={6} className="text-center">
                    <img src={logo_stream} alt="Logo" style={{ maxWidth: '300px' }} />
                </CCol>
            </CRow>

            <CRow className="justify-content-center">
                <CCol md={8}>
                    <CCard>
                        <CCardBody className="text-center">
                            <h4>O processo de preenchimento do inquérito encontra-se concluído.</h4>
                            <h5>Obrigado pela sua colaboração!</h5>
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default IdiSurveyCompleted;
